.layout {
  display: grid;
  grid-template-columns: 13rem minmax(0, 47.5rem) 11.25rem;
  justify-content: center;
  gap: 2.75rem;
  max-width: 1280px;
  margin-inline: auto;
  padding: 2.625rem 1.5rem 5rem;

  @media (max-width: 1100px) { grid-template-columns: 13rem minmax(0, 47.5rem); }
  @media (max-width: 996px) { grid-template-columns: minmax(0, 1fr); }
}

.sidebar {
  position: sticky;
  top: calc(var(--header-height) + 28px);
  align-self: start;
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  font-size: 0.8125rem;

  ul { list-style: none; margin: 0; padding: 0; }
  li { margin: 0.08rem 0; }

  a {
    display: block;
    border-radius: 7px;
    padding: 0.38rem 0.55rem;
    color: var(--gz-muted);
    text-decoration: none;

    &:hover { background: var(--gz-surface); color: var(--gz-fg); }
  }

  @media (max-width: 996px) {
    position: static;
    display: flex;
    gap: 0.25rem;
    margin: -0.5rem -1.5rem 0;
    padding: 0 1.5rem 1rem;
    overflow-x: auto;
    border-bottom: 1px solid var(--gz-line);

    .group { display: flex; flex: none; gap: 0.25rem; margin: 0; }
    .groupLabel { display: none; }
    ul { display: flex; gap: 0.25rem; }
    li { flex: none; }
  }
}

.group + .group { margin-top: 1.2rem; }

.groupLabel {
  margin: 0 0 0.4rem;
  padding-inline-start: 0.6rem;
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--zen-text-muted);
}

.current {
  background: var(--zen-teal-dim);
  color: var(--gz-accent) !important;
}

.main { min-width: 0; }

.content {
  color: var(--zen-text-secondary);
  font-size: 0.9375rem;
  line-height: 1.8;
  overflow-wrap: anywhere;

  h1, h2, h3, h4 {
    color: var(--zen-text-primary);
    font-weight: 710;
    letter-spacing: -0.025em;
    line-height: 1.3;
  }
  h1 { margin: 0 0 1.875rem; font-size: clamp(2rem, 4vw, 2.625rem); }
  h2 { margin: 3rem 0 1.125rem; padding-top: 0.625rem; border-top: 1px solid var(--gz-line); font-size: 1.55rem; }
  h3 { margin: 2rem 0 0.75rem; font-size: 1.2rem; }
  p, ul, ol { margin: 0.875rem 0; }

  code {
    border-radius: 5px;
    padding: 0.1rem 0.35rem;
    font-size: 0.86em;
    background: var(--zen-teal-dim);
    color: var(--zen-teal-strong);
  }

  pre {
    direction: ltr;
    overflow-x: auto;
    border: 1px solid var(--gz-line);
    border-radius: 10px;
    padding: 0.9rem 1rem;
    background: var(--zen-code);

    code { background: none; padding: 0; }
  }

  table {
    display: block;
    overflow-x: auto;
    border-collapse: collapse;
    width: 100%;
    font-size: 0.9rem;

    th, td { border: 1px solid var(--gz-line); padding: 0.5rem 0.7rem; text-align: start; }
    th { background: var(--zen-bg-elevated); color: var(--zen-text-primary); }
  }

  blockquote {
    margin-inline: 0;
    border-inline-start: 3px solid var(--gz-accent);
    padding: 0.2rem 1rem;
    color: var(--zen-text-secondary);
    background: var(--zen-bg-elevated);
  }

  a { color: var(--zen-teal-strong); text-underline-offset: 3px; }
}

.pagination {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 3rem;
  border-top: 1px solid var(--gz-line);
  padding-top: 1.5rem;
  font-size: 0.92rem;

  a { text-decoration: none; }
}

.next { margin-inline-start: auto; }

.toc {
  position: sticky;
  top: calc(var(--header-height) + 28px);
  align-self: start;
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  font-size: 0.82rem;

  ul { list-style: none; margin: 0; padding: 0; }
  li[data-level='3'] { padding-inline-start: 0.8rem; }

  a {
    display: block;
    padding: 0.35rem 0;
    color: var(--zen-text-muted);
    text-decoration: none;

    &:hover { color: var(--gz-accent); }
  }

  @media (max-width: 1100px) { display: none; }
}
